<!--<div class="left-bar-login">-->
<!--</div>-->
<div class="full-page-login">
  <form class="form" [formGroup]="form">
    <div class="item logo-wrapper">
      <div class="logo"></div>
    </div>
    <div class="item email" [class.error]="(emailCtrl.touched || isSubmitting)  && emailCtrl.errors">
      <label for="email" class="label">логин</label>
      <input class="input" type="text" id="email" placeholder="ваш e-mail" [formControl]="emailCtrl">
      <span class="error-message">{{notEmail}}</span>
    </div>
    <div class="item password" [class.error]="(passwordCtrl.touched || isSubmitting) && passwordCtrl.errors">
      <label for="email" class="label">пароль</label>
      <a uiSref="forgotPassword" class="forgot-password">Забыли пароль?</a>
      <input class="input" type="password" id="password" placeholder="Пароль" [formControl]="passwordCtrl">
      <span class="error-message">{{notPassword}}</span>
    </div>
    <div class="item">
      <div class="box-wrapper">
        <app-checkbox [(value)]="isRememberMe"></app-checkbox>
        <span>Запомнить меня</span>
      </div>
    </div>
    <div class="error-message" *ngIf="errorMessage">{{errorMessage}}</div>
    <div class="btn-wrapper">
      <button class="button red-btn" (click)="onSubmit()" [disabled]="isSubmitting">
        Войти
      </button>
    </div>
  </form>
<!--  <span class="copyright">Курсы валют в приложении взяты из источника: <a href="https://www.minfin.com.ua/currency/" target="_blank">www.minfin.com.ua/currency/</a></span>-->
</div>
